import axios from "axios";

const axiosObject = {};

axiosObject.post = async function (url, body) {
  try {
    const response = await axios.post(url, body, { withCredentials: false });
    return response.data;
  } catch (e) {
    // console.log(e);

    // const message = e?.response?.data || "PLEASE TRY AGAIN SHORTLY...";
    // throw new Error(message);

    const errData = e?.response?.data;
    let msg;
    if (typeof errData === "string") {
      msg = errData;
    } else if (errData && typeof errData === "object") {
      msg = errData.msg || errData.message || "PLEASE TRY AGAIN SHORTLY...";
    } else {
      msg = "PLEASE TRY AGAIN SHORTLY...";
    }

    throw new Error(msg);
  }
};
axiosObject.postBlob = async function (url, body) {
  const response = await axios.post(url, body, {
    withCredentials: false,
    responseType: "blob",
  });
  return response.data;
};

axiosObject.postWithAPIKEY = async function (url, body, apikey) {
  try {
    console.log(apikey);

    const response = await axios.post(url, body, {
      withCredentials: false,
      headers: {
        "x-api-key": apikey, // or Authorization
      },
    });
    return response.data;
  } catch (e) {
    console.log(e);

    const message = e?.response?.data || "PLEASE TRY AGAIN SHORTLY...";
    throw new Error(message);
  }
};
axiosObject.put = async function (url, body) {
  try {
    const response = await axios.put(url, body, { withCredentials: false });
    return response.data;
  } catch (e) {
    const message = e?.response?.data || "PLEASE TRY AGAIN SHORTLY...";
    throw new Error(message);
  }
};

axiosObject.patch = async function (url, body) {
  try {
    const response = await axios.patch(url, body);
    return response.data;
  } catch (e) {
    const message = e?.response?.data || "PLEASE TRY AGAIN SHORTLY...";
    throw new Error(message);
  }
};

axiosObject.delete = async function (url, body) {
  try {
    const response = await axios.delete(url, { data: body });
    return response.data;
  } catch (e) {
    const message = e?.response?.data || "PLEASE TRY AGAIN SHORTLY...";
    throw new Error(message);
  }
};

axiosObject.get = async function (url, params) {
  try {
    const response = await axios.get(url, { params });
    return response.data;
  } catch (e) {
    const message = e.response?.data || "PLEASE TRY AGAIN SHORTLY...";
    throw new Error(message);
  }
};

export default axiosObject;
